import OktaAuth from '@okta/okta-auth-js';
import config from 'utils/okta/okta.config';

const oktaAuth = new OktaAuth(config);

export default oktaAuth;

export const useOkta = () => oktaAuth;
